import React from 'react';
import { CgSpinner } from 'react-icons/cg';
import './polarSwitch.css';

// Polar switch component used in question forms. The layout mirrors the
// structure of other standard form components so that fonts and alignment are
// consistent regardless of question type.
export default function PolarSwitch({ title = '', ariaLabel, data = false, setData, loading = false, disabled = false }) {
  const handleChange = (e) => {
    if (setData) {
      setData(e.target.checked);
    }
  };

  const switchControl = loading ? (
    <CgSpinner className='psSwitchSpinner' />
  ) : (
    <label className='polarSwitch'>
      <input
        type='checkbox'
        checked={!!data}
        onChange={handleChange}
        disabled={disabled}
        aria-label={ariaLabel || title || undefined}
      />
      <span className='polarSlider'></span>
    </label>
  );

  // When no title is provided, only render the switch control so that parent
  // components can supply their own labels.
  if (!title) {
    return switchControl;
  }

  return (
    <div className='psFormRow'>
      <span className='psTitleLabel'>{title}</span>
      {switchControl}
    </div>
  );
}
